<!-- 
Expander panel showing the completion rate calculation.
-->
<template>
  <div>
    <a
      :id="'focus-' + panelNumber"
      href="#" class="section-heading subheading d-block pl-4 pr-5 pt-3 pb-3"
      @click.stop.prevent="$emit('click:togglePanel', panelCourseCompletionScore)"
    >
      <v-icon class="sub-breakdown">subdirectory_arrow_right</v-icon>
      Risk factor value: Completion rate
      <v-btn icon class="focus-button" tabindex="-1">
        <v-icon :class="'expand-icon ' + (expanded ? 'expanded' : '')">expand_more</v-icon>
      </v-btn>
    </a>
    <v-expand-transition>
      <v-card v-show="expanded" flat>
        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
        <div v-if="!isInternal" class="caption pl-4 pr-4 pt-2" v-html="templates.CourseCompletionScore"/>
        <v-card-text class="pt-2 px-0 pb-0">
          <v-layout row wrap mx-4>
            <v-flex 
              xs12 sm4 mt-2 pt-1 
              class="text-xs-right"
            >
              <our-data-field :label="`Completion rate formula (using ${levyCollection.year - 1} EFTSL)`" label-width="11">
                Passed 
                / 
                (Passed + Withdrawn + Failed + Ongoing + Missing)
              </our-data-field>
              <our-data-field v-if="noStudents" label="Completion rate" label-width="11">
                No students
                <br>
                (minimum risk factor value applies)
              </our-data-field>
              <our-data-field v-else label="Completion rate" label-width="11">
                {{ levyParameters.passedEftsl | numericInput3 }} 
                /
                ({{ levyParameters.passedEftsl | numericInput3 }} 
                + 
                {{ levyParameters.withdrawnEftsl | numericInput3 }} 
                +
                {{ levyParameters.failedEftsl | numericInput3 }} 
                +
                {{ levyParameters.ongoingEftsl | numericInput3 }} 
                +
                {{ levyParameters.missingEftsl | numericInput3 }})
                =
                <precise-risk-factor-number 
                  :value="levyCalculation.completionRate"
                  :decimal-places="3"
                  :levy-collection-id="levyCollection.id" 
                  :estimator-key="estimatorKey" 
                  type="CourseCompletion"
                  is-percentage
                />
              </our-data-field>
            </v-flex>
            <v-flex xs12 sm4 pb-4>
              <risk-factor-table
                :estimator-key="estimatorKey" 
                :levy-collection-id="levyCollection.id" 
                :selected-score="levyCalculation.courseCompletionScore" 
                is-percentage 
                type="CourseCompletion" 
                title="Completion rate"
              />
            </v-flex>
            <v-flex 
              xs12 sm4 mt-2 pt-1 
              class="text-xs-right"
            >
              <our-data-field label="Completion rate risk factor value" typography="title" label-width="11">
                {{ levyCalculation.courseCompletionScore | numericInput2 }}
                <template v-slot:footer>
                  <playground-up-down v-if="isLevyEstimator" field="courseCompletionScore" show-original small/>
                </template>
              </our-data-field>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import mixins from "./mixins";
import PlaygroundUpDown from "@/components/levy-collection-providers/calculation/PlaygroundUpDown.vue";
import RiskFactorTable from "@/components/levy-collection-providers/calculation/RiskFactorTable.vue";
import PreciseRiskFactorNumber from "@/components/levy-collection-providers/calculation/PreciseRiskFactorNumber.vue";

export default {
  components: {
    PlaygroundUpDown,
    RiskFactorTable,
    PreciseRiskFactorNumber
  },
  mixins: [filterMixins, mixins],
  props: {
    expanded: {
      type: Boolean,
      required: true
    },
    panelNumber: {
      type: Number,
      required: true
    }
  },
  computed: {
    noStudents() {
      return this.totalEftsl == 0;
    },
    totalEftsl() {
      return (
        this.levyParameters.passedEftsl +
        this.levyParameters.withdrawnEftsl +
        this.levyParameters.failedEftsl +
        this.levyParameters.ongoingEftsl +
        this.levyParameters.missingEftsl
      );
    }
  }
};
</script>
